export const SET_LOADING_STATUS = 'users.SET_LOADING_STATUS';
export const FETCH_CURRENT_USER = 'users.FETCH_CURRENT_USER';
export const FETCH_USER_BY_ID = 'users.FETCH_USER_BY_ID';
